import "../LibraryBoxBattle.scss";
import Dialog from "../../../1. Core/Controls/Dialog/Dialog";
import NP from "../../../1. Core/NP";
import Select from "../../../1. Core/Controls/Select/Select";
import TextField from "../../../1. Core/Controls/TextField/TextField";
import ListBox, {ListBoxItemArgs} from "../../../1. Core/Controls/ListBox/ListBox";
import {ServerAPI} from "../../../1. Core/ServerAPI";
import IconSelect from "../../../1. Core/Controls/Select/IconSelect";
import ListGroupHeader from "../../../1. Core/Controls/ListBox/ListGroupHeader";
import {getStages, getTournaments, getWeights, getWeightString, ITournament, Weight} from "../../Util";
import NumField from "../../../1. Core/Controls/TextField/NumField";
import './EditBoutDialog.scss';
import {EventTournament, SportType} from "../../types";
import TimeEdit, {TimeEditMode} from "../../../1. Core/Controls/TimeEdit/TimeEdit";
import CheckBox from "../../../1. Core/Controls/CheckBox/CheckBox";
import DateInput from "../../../1. Core/Controls/DateInput/DateInput";
import SelectFighterCtrl from "../../../2. Athletes/SelectFighterCtrl";

let moment = require('moment');

export default class CreateBoutDialog extends Dialog {

	_IsNew: boolean;
	_Date: Date;
	_Winner: number;

	_chooseWinnerListHeader: ListGroupHeader;
	_chooseWinnerList: ListBox;
	_redCombo: SelectFighterCtrl;
	_blueCombo: SelectFighterCtrl;
	_tournamentCombo: IconSelect;
	_genderCombo: IconSelect;
	_weightCombo: IconSelect;
	_stageCombo: IconSelect;
	_dateInput: DateInput;
	private _winTypeSelect: Select;
	private _roundCountInput: NumField;

	private _roundLengthInput: NumField;
	private _winDesc: TextField;
	private _statusSelect: Select;
	private _eventInput: Select;
	private _SportType: SportType;
	private _endTime: TimeEdit;
	private _filterAthletesByTournamet: CheckBox;
	private _currentTEvents: EventTournament[];
	private _fileVideoPath: TextField;

	_initFields(settings: object)
	{
		this._IsNew = false;
		this._Winner = null;
		this._Date = moment().toDate();
		this._SportType = SportType.MMA;
		super._initFields(settings);
		this._Mode = 'FullHeight';
		this._Caption = NP.RM.getString('CreateBout');
		this._CloseOnFrameMouseDown = true;
		this._ShowHeader = true;
		this._ShowCloseButton = true;
		this._OkRK = 'CreateBout'
	}


	_render()
	{
		super._render();
		let dialogContent = NP.createNode(this._contentNode, 'app-list-group');

		this._tournamentCombo = new IconSelect({
			ParentNode: dialogContent,
			FloatingLabel: NP.RM.getString('Tournament'),
			EvItemSelected: () =>
			{
				this.updateEvents();
				this._refreshBoxers();
				this._dateInput.setEnabled(true)
			}
		});

		let evenContainer = NP.createNode(dialogContent, 'event-info__container');
		this._eventInput = new Select({
			ParentNode: evenContainer,
			FloatingLabel: NP.RM.getString('Event'),
			EvItemSelected: () =>
			{

				let id = this._eventInput.getValue();
				let ev = this._currentTEvents.find(ev => ev.Id == id)
				if (ev.Date)
				{
					this._Date = moment(ev.Date).toDate();
					this._dateInput.setValue(this._Date);
					this._dateInput.setEnabled(false)
				}
				else
					this._dateInput.setEnabled(true)
			}
		});


		this._stageCombo = new IconSelect({
			ParentNode: dialogContent,
			FloatingLabel: NP.RM.getString('Stage'),
		});

		this._dateInput = new DateInput({
			ParentNode: dialogContent,
			FloatingLabel: NP.RM.getString('Date'),
			FontImage: NP.FontImages.event,
			EnabledEdit: false,
			Value: new Date(),
			EvChanged: () =>
			{
				this._Date = this._dateInput.getValue();
			}
		});


		this._fileVideoPath = new TextField({
			ParentNode: dialogContent,
			FloatingLabel: NP.RM.getString('PathToVideoFile')
		})


		this._roundCountInput = new NumField({
			ParentNode: dialogContent,
			SpinEdit: true,
			Min: 1,
			Max: 15,
			Value: this._SportType == SportType.MMA || this._SportType == SportType.KB ? 3 : 12,
			FloatingLabel: NP.RM.getString('NumberOfRounds')
		});

		this._roundLengthInput = new NumField({
			ParentNode: dialogContent,
			SpinEdit: true,
			Value: this._SportType == SportType.MMA ? 5 : 3,
			Min: 1,
			Max: 5,
			FloatingLabel: NP.RM.getString('RoundLength')
		});

		this._genderCombo = new IconSelect({
			ParentNode: dialogContent,
			FloatingLabel: NP.RM.getString('Gender'),
			SelectedIndex: 0,
			Items: [{
				Value: 1,
				FontImage: NP.FontImages.gender,
				Content: NP.RM.getString('MaleGender')
			}, {
				Value: 0,
				FontImage: NP.FontImages.gender,
				Content: NP.RM.getString('FemaleGender')
			}],
			EvItemSelected: () =>
			{
				this.updateWeightSelect();
			}
		});

		this._weightCombo = new IconSelect({
			ParentNode: dialogContent,
			FloatingLabel: NP.RM.getString('WeightCategory')
		});

		this._filterAthletesByTournamet = new CheckBox({
			ParentNode: dialogContent,
			RK: 'FilterAthleteByTournament',
			Checked: true,
			EvCheckedChanged: () => this._refreshBoxers()
		})

		this._redCombo = new SelectFighterCtrl({
			ParentNode: dialogContent,
			SportType: this._SportType,
			FloatingLabel: NP.RM.getString('Red'),
			EvSelected: () => this._updateWinnerRadio(),
			AllowCreateNew: true,
			Gender: 1
		});

		this._blueCombo = new SelectFighterCtrl({
			ParentNode: dialogContent,
			SportType: this._SportType,
			FloatingLabel: NP.RM.getString('Blue'),
			EvSelected: () => this._updateWinnerRadio(),
			AllowCreateNew: true,
			Gender: 1
		});

		this._statusSelect = new Select({
			ParentNode: dialogContent,
			FloatingLabel: NP.RM.getString('Status'),
			SelectedIndex: 0,
			Items: [
				{RK: 'NotStarted', Value: 'Not started'},
				{RK: 'InProgress', Value: 'In progress'},
				{RK: 'Finished', Value: 'Finished'},
				{RK: 'Canceled', Value: 'Canceled'}
			],
			EvItemSelected: () =>
			{
				this._updateWinnerRadio()
			}
		});

		this._chooseWinnerListHeader = new ListGroupHeader({
			ParentNode: dialogContent,
			RK: 'Winner',
			IsVisible: false
		});
		this._chooseWinnerList = new ListBox({
			ParentNode: dialogContent,
			EvItemSelected: (s: ListBox, e: ListBoxItemArgs) =>
			{
				this._Winner = e.Item.getValue();
				this._updateControls();
			}
		});

		this._winTypeSelect = new Select({
			ParentNode: dialogContent,
			FloatingLabel: NP.RM.getString('WinType').replace("{0}:", ""),
			Value: 'WP',
			Items: CreateBoutDialog.getWinTypeItems()
		});
		this._chooseWinnerList.setIsVisible(false);
		this._winTypeSelect.setIsVisible(false);

		this._endTime = new TimeEdit({
			ParentNode: dialogContent,
			FloatingLabel: NP.RM.getString('WinTime'),
			FontImage: NP.FontImages.url,
			Mode: TimeEditMode.MinutesSeconds
		});

		this._endTime.setIsVisible(false);

		this._winDesc = new TextField({
			ParentNode: dialogContent,
			FloatingLabel: NP.RM.getString('WinDescription')
		});
	}

	static getWinTypeItems()
	{
		return [{
			RK: "WinType_KO",
			Value: "KO"
		}, {
			RK: "WinType_TKO",
			Value: "TKO"
		}, {
			RK: "WinType_UD",
			Value: "UD"
		}, {
			RK: "WinType_MD",
			Value: "MD"
		}, {
			RK: "WinType_SD",
			Value: "SD"
		}, {
			RK: "WinType_DQ",
			Value: "DQ"
		}, {
			RK: "WinType_NC",
			Value: "NC"
		}, {
			RK: "WinType_TD",
			Value: "TD"
		}, {
			RK: "WinType_SUB",
			Value: "SUB"
		}, {
			RK: "WinType_TB",
			Value: "TB"
		}, {
			Content: "DRAW",
			Value: "DRAW"
		}]
	}

	updateWeightSelect()
	{
		getWeights({Type: this._SportType}).then((res: Weight[]) =>
		{
			if (this._weightCombo)
			{
				if (this._tournamentCombo.getSelectedItem() && this._SportType == SportType.Box)
				{
					let isPro = this._tournamentCombo.getSelectedItem().Data.IsPro;
					res = res.filter(w => w.IsPro == isPro);
				}

				let sex = this._genderCombo.getValue();
				res = res.filter(w => w.Sex == sex);

				let items = res.map(w => ({Value: w.Id, FontImage: NP.FontImages.weight, Content: getWeightString(w)}));

				if (items.length)
				{
					this._weightCombo.setEnabled(true);
					this._weightCombo.setItems(items, true);
					this._weightCombo.setSelectedIndex(0, false);
				}
				else
				{
					this._weightCombo.setValue(null, false);
					this._weightCombo.setEnabled(false);
				}

				this._refreshBoxers()
			}
		});
	}

	refresh()
	{

		this.updateWeightSelect();

		this.updateTournamentList();


		if (this._stageCombo)
		{
			let items = getStages().map(s => ({Value: s, FontImage: NP.FontImages.list, Content: s}));
			this._stageCombo.addItems(items);
			this._stageCombo.setSelectedIndex(0, false);
		}


		return this;
	}

	updateTournamentList()
	{
		getTournaments(this._SportType).then((res: ITournament[]) =>
		{
			if (this._tournamentCombo)
			{
				let items = res.map(t => ({Value: t.Id, FontImage: NP.FontImages.event, Content: t.Name, Data: t}));
				this._tournamentCombo.addItems(items);
				this._tournamentCombo.setSelectedIndex(0, true);

				this.updateEvents();
			}
		});
	}

	formatDate(d: string)
	{
		return moment(d, 'YYYY-MM-DD HH:mm:ss.S').format('YYYY-MM-DD')
	}

	async updateEvents()
	{
		let response = await ServerAPI.callUiApi("/t-events", {
			Count: 500,
			Offset: 0,
			SportType: this._SportType,
			TournamentId: this._tournamentCombo.getValue()
		}, 'POST') as { List: EventTournament[], AllCount: number };

		this._currentTEvents = response.List;

		this._eventInput.setItems(response.List.map(it => ({Content: `${it.Name}  -  ${this.formatDate(it.Date)}`, Value: it.Id})));
	}

	_refreshBoxers()
	{
		this._blueCombo.setGender(this._genderCombo.getValue())
		this._redCombo.setGender(this._genderCombo.getValue())
		this._blueCombo.setTournament(this._filterAthletesByTournamet.getChecked() ? this._tournamentCombo.getValue() : null)
		this._redCombo.setTournament(this._filterAthletesByTournamet.getChecked() ? this._tournamentCombo.getValue() : null)
	}


	_updateWinnerRadio()
	{
		this._chooseWinnerList.clear();

		let redAthlete = this._redCombo.getSelectedAthlete()
		if (redAthlete)
			this._chooseWinnerList.addItem({
				Value: this._redCombo.getValue(),
				Content: `${redAthlete.FirstName} ${redAthlete.LastName}`,
				IsRadioButton: true
			});

		let blueAthlete = this._blueCombo.getSelectedAthlete()
		if (blueAthlete)
			this._chooseWinnerList.addItem({
				Value: this._blueCombo.getValue(),
				Content: `${blueAthlete.FirstName} ${blueAthlete.LastName}`,
				IsRadioButton: true
			});

		this._chooseWinnerList.addItem({
			Value: ' ',
			RK: 'Draw',
			IsRadioButton: true
		});

		let vis = this._chooseWinnerList.getItems().length == 3 && this._statusSelect.getValue() != 'Not started' && this._statusSelect.getValue() != 'Canceled';
		this._chooseWinnerList.setIsVisible(vis);
		this._chooseWinnerListHeader.setIsVisible(vis);
		this._winTypeSelect.setIsVisible(vis);
		this._endTime.setIsVisible(vis);
		this._winDesc.setIsVisible(vis);
		this._updateControls();
	}

	_updateControls()
	{
		let hasWinner = this._redCombo.getValue() && this._blueCombo.getValue() && this._redCombo.getValue() != this._blueCombo.getValue() && this._Winner != null;
		this.getOkButton().setEnabled(hasWinner || this._statusSelect.getValue() == 'Not started' || this._statusSelect.getValue() == 'Canceled');
	}

	_onOkButtonClick()
	{
		let payload = {
			Type: this._SportType,
			Createts: moment().format('YYYY-MM-DD HH:mm:ss.S'),
			Red: this._redCombo.getValue(),
			Blue: this._blueCombo.getValue(),
			Winner: this._chooseWinnerList.getValue() == ' ' ? null : this._chooseWinnerList.getValue(),
			TournamentId: this._tournamentCombo.getValue(),
			EventId: this._eventInput.getValue(),
			Stage: this._stageCombo.getValue(),
			Date: moment(this._Date).format('YYYY-MM-DD HH:mm:ss.S'),
			WinType: this._winTypeSelect.getValue(),
			WeightId: this._weightCombo.getValue(),
			VideoUrl: this._fileVideoPath.getValue(),
			RoundCount: this._roundCountInput.getValue(),
			RoundLength: this._roundLengthInput.getValue(),
			WinDescription: this._winDesc.getValue(),
			Status: this._statusSelect.getValue(),
			EndTime: this._endTime.getValue() ? '00:' + this._endTime.getValue() : null
		};

		if (payload.Status == 'Not started')
			payload.WinType = null;

		ServerAPI.callUiApi(`/battle`, payload, 'POST').then(() =>
		{
			super._onOkButtonClick();
		});
	}
}
